import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { QueryManagerComponent } from './query-manager/query-manager.component';
import { QueryPropertiesComponent } from './query-properties/query-properties.component';

@NgModule({
  declarations: [
    QueryManagerComponent,
    QueryPropertiesComponent,
  ],
  imports: [SharedModule],
})
export class QueryBuildModule {}
